import { render, staticRenderFns } from "./x-cropper.vue?vue&type=template&id=c4125c90&scoped=true&"
import script from "./x-cropper.vue?vue&type=script&lang=js&"
export * from "./x-cropper.vue?vue&type=script&lang=js&"
import style0 from "./x-cropper.vue?vue&type=style&index=0&id=c4125c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4125c90",
  null
  
)

export default component.exports